// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchSimilarItemsParams = {
    authToken: string,
    deployment: string,
    searchExclusions: number[],
    similarItemInfo: any,
};

export const fetchSimilarItems = ({
    authToken,
    deployment,
    similarItemInfo,
    searchExclusions = [],
}: FetchSimilarItemsParams) =>
    new Promise<any>((resolve, reject) => {
        const params = {
            options: {
                auctionHouse: [{ exclude: searchExclusions, include: [] }],
                status: ['upcoming', 'live', 'online'],
            },
            pageSize: 16,
            searchTerm: similarItemInfo.title,
        };

        const request = makeGet({
            apiPath: 'similaritems',
            authToken,
            deployment,
            path: '<SEARCH-API>',
            queryParams: {
                houseId: similarItemInfo.sellerId,
                ids: JSON.stringify(similarItemInfo.categoryIds),
                parameters: JSON.stringify(params),
            },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export const fetchSimilarItemsV3 = ({
    authToken,
    deployment,
    similarItemInfo,
    searchExclusions = [],
}: FetchSimilarItemsParams) =>
    new Promise<any>((resolve, reject) => {
        const params = {
            options: {
                auctionHouse: [{ exclude: searchExclusions, include: [] }],
                status: ['upcoming', 'live', 'online'],
            },
            pageSize: 16,
            searchTerm: similarItemInfo.title,
        };

        const request = makeGet({
            apiPath: 'similaritems-v3',
            authToken,
            deployment,
            path: '<SEARCH-API>',
            queryParams: {
                houseId: similarItemInfo.sellerId,
                ids: JSON.stringify(similarItemInfo.categoryIds),
                parameters: JSON.stringify(params),
            },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
